import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .info {
    flex: 1;
  }

  .bottom {
    flex: 0;

    span {
      font-weight: ${ThemePrisma.fonts.title.xl.highContrast.fontWeight};
    }
  }
`;
